import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from '../components/Header';
import Select from 'react-select';
import { motion } from 'framer-motion';

function AddTransactions() {
  const [formData, setFormData] = useState({
    amount: '',
    transaction_date: '',
    payment_type: '',
    check_number: '',
    description: '',
    currency_type: '',
    cash_in_type: '',
    store_id: '',
    file: null,
  });

  const [stores, setStores] = useState([]);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [userCurrency, setUserCurrency] = useState('');

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        const [userResponse, storeResponse] = await Promise.all([
          axios.get('/user/profile', {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get('/user/stores', {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        setUserCurrency(userResponse.data.currency);
        setFormData((prev) => ({ ...prev, currency_type: userResponse.data.currency }));

        if (Array.isArray(storeResponse.data)) {
          setStores(storeResponse.data);
        } else if (storeResponse.data?.stores && Array.isArray(storeResponse.data.stores)) {
          setStores(storeResponse.data.stores);
        } else {
          setStores([]);
        }
      } catch (err) {
        console.error('Error fetching data:', err);
        setError('Failed to fetch data.');
      }
    };

    fetchUserData();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === 'file') {
      setFormData({ ...formData, file: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleStoreChange = (selectedOption) => {
    setFormData({ ...formData, store_id: selectedOption ? selectedOption.value : '' });
  };

  const storeOptions = stores.map((store) => ({
    value: store.id,
    label: `${store.storename} (${store.storeid})`,
  }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (formData.currency_type !== userCurrency) {
      setError(`Invalid currency. You can only use ${userCurrency}.`);
      return;
    }

    const form = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === 'amount') {
        form.append(key, Number(formData[key]));
      } else if (key !== 'file') {
        form.append(key, formData[key]);
      }
    });

    if (formData.file) {
      form.append('file', formData.file);
    }

    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.post(
        '/user/addTransaction',
        form,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      setMessage(response.data.message);
      alert(response.data.message);

      setFormData({
        amount: '',
        transaction_date: '',
        payment_type: '',
        check_number: '',
        description: '',
        currency_type: userCurrency,
        cash_in_type: '',
        store_id: '',
        file: null,
      });
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred. Please try again.');
    }
  };

  return (
    <div>
      <Header />
      <motion.div
        className="container mt-5"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        <motion.h2
          className="text-center mb-4"
          initial={{ scale: 0.95 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2 }}
        >
          Add Transaction
        </motion.h2>

        {message && (
          <motion.div
            className="alert alert-success"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            {message}
          </motion.div>
        )}

        {error && (
          <motion.div
            className="alert alert-danger"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            {error}
          </motion.div>
        )}

        <motion.form
          onSubmit={handleSubmit}
          className="card p-4 shadow"
          encType="multipart/form-data"
          initial={{ opacity: 0, scale: 0.98 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4 }}
        >
          <div className="mb-3">
            <label className="form-label">Store</label>
            <Select
              options={storeOptions}
              value={storeOptions.find((option) => option.value === formData.store_id)}
              onChange={handleStoreChange}
              isClearable
              placeholder="Select a Store..."
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Payment Type</label>
            <select
              name="payment_type"
              className="form-select"
              value={formData.payment_type}
              onChange={handleChange}
              required
            >
              <option value="">Select Payment Type</option>
              <option value="cash">Cash</option>
              <option value="cheque">Cheque</option>
            </select>
          </div>

          {formData.payment_type === 'cheque' && (
            <div className="mb-3">
              <label className="form-label">Cheque Number</label>
              <input
                type="number"
                name="check_number"
                className="form-control"
                value={formData.check_number}
                onChange={handleChange}
                required
              />
            </div>
          )}

          <div className="mb-3">
            <label className="form-label">Amount</label>
            <input
              type="number"
              name="amount"
              className="form-control"
              value={formData.amount}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Transaction Date</label>
            <input
              type="date"
              name="transaction_date"
              className="form-control"
              value={formData.transaction_date}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Description</label>
            <textarea
              name="description"
              className="form-control"
              rows="3"
              value={formData.description}
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="mb-3">
            <label className="form-label">Currency Type</label>
            <input
              type="text"
              name="currency_type"
              className="form-control"
              value={userCurrency}
              disabled
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Cash-in Type</label>
            <select
              name="cash_in_type"
              className="form-select"
              value={formData.cash_in_type}
              onChange={handleChange}
              required
            >
              <option value="">Select Cash-in Type</option>
              <option value="retail">Retail</option>
              <option value="service">Service</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Upload Image or PDF</label>
            <input
              type="file"
              name="file"
              className="form-control"
              onChange={handleChange}
              accept="image/*, application/pdf"
            />
          </div>

          <motion.button
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            transition={{ type: 'spring', stiffness: 300 }}
            type="submit"
            className="btn btn-primary w-100"
          >
            Add Transaction
          </motion.button>
        </motion.form>
      </motion.div>
    </div>
  );
}

export default AddTransactions;
